import { Box, Link, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';

export const Step2Shopware: FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				// alignItems: 'center',
				// justifyContent: 'center',
				mt: '20px',
				gap: '40px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					// mt: '20px',
					width: 'calc(100%)',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						The store can&apos;t be connected directly from the Dashboard.
					</Typography>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						Currently EAS solution supports only Shopware 6 platform.
					</Typography>

					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						To connect your Shopware 6 store:
					</Typography>
					<Typography
						component="div"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						<List dense>
							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0  8px 0',
								}}
							>
								1. Download&nbsp;
								<Link
									href="https://shopware6-app.easproject.com/release/EAS-EU-Compliance.zip"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									EAS EU and UK application.
								</Link>
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								2. Install and configure application following instructions provided in the&nbsp;
								<Link
									href="https://help.easproject.com/shopware-6"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									help center article.
								</Link>
							</ListItem>
						</List>
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
